import React, { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import ConditionalWrapper from '@wix/da-shared-react/pkg/ConditionalWrapper';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import { default as Custom, Props } from './Custom';
import reduxConnectContainer from './Custom.container';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import WidgetPaywall from '../_partials/paywalls/WidgetPaywall';

const Edit = lazy(() => import(/* webpackChunkName: "owner" */ './Edit'));

const CustomBox: React.FC<Props & WidgetBoxProps> = props => {
  const {
    title,
    moduleId,
    position,
    widgetMoveUp,
    widgetRemove,
    widgetMoveDown,
    widgetAddColumn,
    widgetBoxClassName,
    isCurrentUserCoreMember,
    showCoreUpsell,
    section,
    zone,
  } = props;
  const { t } = useTranslation();

  const renderEditMenu = closeMenu => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <Edit
          moduleId={moduleId}
          onRequestClose={closeMenu}
          widgetRemove={widgetRemove}
        />
      </Suspense>
    );
  };

  return (
    <WidgetBox
      section={section}
      zone={zone}
      moduleId={moduleId}
      header={String(title || '').trim() || ' '}
      autoShowWidgetConfig={true}
      widgetMenuRenderer={closeMenu => renderEditMenu(closeMenu)}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      widgetAddColumn={widgetAddColumn}
      className={widgetBoxClassName}
      editControlsTooltipContent={
        !isCurrentUserCoreMember && t('widgets.custombox.edit.tooltip')
      }
    >
      <ConditionalWrapper
        condition={showCoreUpsell}
        wrap={child => <WidgetPaywall>{child}</WidgetPaywall>}
      >
        <Custom {...props} zone={zone} position={position} />
      </ConditionalWrapper>
    </WidgetBox>
  );
};

CustomBox.displayName = 'CustomBox';

export default reduxConnectContainer(CustomBox);
